import { render } from "./asset-position.vue?vue&type=template&id=58020e63&scoped=true"
import script from "./asset-position.vue?vue&type=script&lang=js"
export * from "./asset-position.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-58020e63"

export default script